import { createContext, useContext, useEffect, useState } from "react";
import useSWR from "swr";
import { Spinner } from "flowbite-react";

import LoginPage from "../components/LoginPage";

const UserContext = createContext();

const fetchUserDetail = async () => {
  try {
    const userDetail = await window.catalyst.auth.isUserAuthenticated();
    const mainData = userDetail?.content;
    const { user_id } = mainData;

    const crmUserDetailResponse = await fetch(
      "/server/dealer_backend/dealer-detail",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: user_id }),
      }
    );

    const responseJson = await crmUserDetailResponse.json();

    if (!responseJson.dealerData) {
      throw new Error("Unexpected response structure");
    }

    const { dealerData, associatedContacts } = responseJson;
    const dealer = dealerData.dealer || {};
    const InventoryCustomerData = dealerData.InventoryCustomerData || {};
    let parentAccountAddresses = dealerData.parentAccountAddresses || [];
    const contactAddresses = dealerData.contactAddresses || [];

    if (contactAddresses?.length)
      parentAccountAddresses = parentAccountAddresses.concat(contactAddresses);

    const isChannelPartner = dealer.dealerType === "Channel Partner";
    const accountName = isChannelPartner
      ? { name: dealer?.Account_Name, id: dealer?.id }
      : {
          name: dealerData?.parentAccount?.Account_Name,
          id: dealerData?.parentAccount?.id,
        };

    const dealerName = isChannelPartner
      ? { name: "Channel Partner", id: null }
      : {
          name: `${dealer?.First_Name ? dealer.First_Name + " " : ""}${
            dealer?.Last_Name
          }`,
          id: dealer?.id,
        };

    const dealerDiscountPercentage =
      dealerData?.parentAccount?.Price_Tier2 ?? dealer?.Price_Tier2 ?? 0;

    const result = {
      mainData,
      crmUserDetail: dealer,
      associatedContacts: associatedContacts?.data || [],
      billingAddresses: [],
      inHouseShipping: [],
      endCustomerShipping: [],
      accountName,
      dealerName,
      isChannelPartner,
      parentAccount: dealerData?.parentAccount,
      dealerDiscountPercentage,
      InventoryCustomerData,
    };

    const addUniqueAddress = (array, address) => {
      const isDuplicate = array.some(
        (existingAddress) => existingAddress.id === address.id
      );
      if (!isDuplicate) array.push(address);
    };

    const processAddresses = (addresses) => {
      addresses.forEach((address) => {
        const addressType = address.Address_Type1;
        const isInHouse = address.Address_Type === "Channel Partner Warehouse";
        const isEndCustomer = address.Address_Type === "End Customer";

        if (addressType === "Billing" || addressType === "Both") {
          addUniqueAddress(result.billingAddresses, address);
        }
        if (addressType === "Shipping" || addressType === "Both") {
          if (isInHouse) {
            addUniqueAddress(result.inHouseShipping, address);
          } else if (isEndCustomer) {
            addUniqueAddress(result.endCustomerShipping, address);
          }
        }
      });
    };

    // Process dealer addresses
    if (dealer.Account_Name) {
      processAddresses(dealerData.addresses || []);
    } else if (dealer.First_Name) {
      processAddresses(dealerData.contactAddresses || []);
    }

    // Include parent account addresses as well
    processAddresses(parentAccountAddresses);

    return result;
  } catch (error) {
    console.error("Error in fetching user details:", error);
    return false;
  }
};

export const UserContextProvider = ({ children }) => {
  const { data: dealerDetail, isLoading } = useSWR("/user", fetchUserDetail);
  const [priceItem, setisPriceitem] = useState(null);
  console.log({ dealerDetail });

  useEffect(() => {
    const InventoryPriceListItme = async () => {
      try {
        // const id = dealerDetail?.InventoryCustomerData?.contact_id;
        // if (!id) {
        //   console.log(
        //     "ID is missing. Unable to fetch inventory contact details."
        //   );
        //   return;
        // }
        // // Fetch data from the backend
        // const response = await fetch(
        //   `/server/dealer_backend/inventorycontactdetails?id=${id}`
        // );

        // console.log({response});

        // if (!response.ok) {
        //   throw new Error(`Failed to fetch: ${response.statusText}`);
        // }

        // const result = await response.json();
        // // console.log(
        // //   "result....",
        // //   result?.contactDetails?.contact?.pricebook_id
        // // );
        console.log(
          "Pricelist",
          dealerDetail?.InventoryCustomerData?.pricebook_id
        );
        const priceItem = await PricebookItem(
          dealerDetail?.InventoryCustomerData?.pricebook_id
        );

        console.log({ priceItem });
        setisPriceitem(priceItem);
      } catch (error) {
        console.error("Error fetching inventory contact details:", error);
      }
    };

    const PricebookItem = async (id) => {
      try {
        if (!id) {
          console.error(
            "ID is missing. Unable to fetch PriceBookItem details."
          );
          return;
        }
        // Fetch data from the backend
        const response = await fetch(
          `/server/dealer_backend/pricebooks?id=${id}`
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.statusText}`);
        }

        const result = await response.json();
        // console.log("result.........",result);
        return result?.contactDetails?.pricebook?.pricebook_items;
      } catch (error) {
        console.error("Error fetching inventory PriceBookItem details:", error);
      }
    };
    InventoryPriceListItme();
  }, [dealerDetail?.InventoryCustomerData?.contact_id]);

  return (
    <UserContext.Provider value={{ dealerDetail, isLoading, priceItem }}>
      {isLoading ? (
        <div className="flex h-screen w-screen justify-center items-center">
          <Spinner
            color="failure"
            aria-label="Failure spinner example"
            size="lg"
          />
        </div>
      ) : dealerDetail ? (
        children
      ) : (
        <LoginPage />
      )}
    </UserContext.Provider>
  );
};

export const useUserServices = () => {
  return useContext(UserContext);
};
